var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "cgi-grid" },
    [
      _c(
        "transition-group",
        { staticClass: "grid-cpt", attrs: { name: "fade", tag: "div" } },
        _vm._l(_vm.filteredCGI, function (post, index) {
          return _c(
            "div",
            {
              key: post.ID,
              staticClass: "grid-cpt__item",
              class: _vm.widthClass(index),
              style: {
                "background-image":
                  "url(" + post.acf.background_image_archive.sizes.large + ")",
              },
              on: {
                mouseover: function ($event) {
                  return _vm.videoPlay("video" + post.ID)
                },
                mouseleave: function ($event) {
                  return _vm.videoPause("video" + post.ID)
                },
                click: function ($event) {
                  return _vm.showPopup("video" + post.ID)
                },
              },
            },
            [
              _c("video", {
                staticClass: "grid-cpt__item__video",
                attrs: {
                  id: "video" + post.ID,
                  "data-imagepopup": post.acf.popup_image
                    ? post.acf.popup_image.url
                    : "",
                  "data-popuptime": post.acf.popup_settings
                    ? post.acf.popup_settings.time_poster !== "custom"
                      ? post.acf.popup_settings.time_poster
                      : post.acf.popup_settings.custom_time
                    : "",
                  preload: "none",
                  loop: "",
                  muted: "",
                  playsinline: "",
                  src: post.acf.hover_video_archive,
                },
                domProps: { muted: true },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "grid-cpt__item__title" }, [
                _vm._v("click to view full render"),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid-cpt__loadmore" }, [
        _vm.postsNumer < _vm.filteredCGI.length
          ? _c(
              "div",
              {
                staticClass: "grid-cpt__loadmore__btn",
                on: {
                  click: function ($event) {
                    _vm.postsNumer += _vm.postsPerPage
                  },
                },
              },
              [_vm._v("Load more")]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }